import { api } from '../core';

interface UpdateTimelineEntryTimeResponse {
  success: boolean;
}

interface UpdateTimelineEntryTimeProps {
  abortController?: AbortController;
  entryId: string;
  time: string | null;
}

const timelineEntryTimeUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateTimelineEntryTime: builder.query<UpdateTimelineEntryTimeResponse, UpdateTimelineEntryTimeProps>({
      query: ({ abortController = new AbortController(), entryId, time }: UpdateTimelineEntryTimeProps) => ({
        url: 'timeline/entry/time/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          time
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateTimelineEntryTime in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateTimelineEntryTimeQuery } = timelineEntryTimeUpdateApi;
